export default {
  setFiles(state, files) {
    state.files = files;
  },
  setFilesLoading(state, loading) {
    state.filesLoading = loading;
  },
  setCurrentFile(state, file) {
    state.currentFile = file;
  },
  setCurrentFileMeta(state, meta) {
    state.currentFileMeta = meta;
  },
  setMetaLoading(state, loading) {
    state.metaLoading = loading;
  }
};
